import { useTheme } from 'styled-components'
import { IFooterProps } from '../Footer'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useState } from 'react'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { useAuth } from 'pages/auth/hooks/useAuth'

export const useFooter = ({ backendUser }: IFooterProps) => {
  const theme = useTheme()
  const { isDevice } = useScreenSizes()
  const [showPolicy, setShowPolicy] = useState(false)
  const [showSecurity, setShowSecurity] = useState(false)
  const [showTerms, setShowTerms] = useState(false)
  const { logEventAnalytics } = useAnalytics()
  const { backendPartner } = useAuth()

  const handlerTracker = (eventType: string) => {
    const partnerLog = {}
    const userLog = {}
    userLog['User ID'] = backendUser?.id
    if (backendUser?.partnerId) {
      partnerLog['Partner ID'] = backendPartner?.id
      partnerLog['Company Name'] = backendPartner?.name
      partnerLog['Account Type'] = 'Partner'
    } else {
      userLog['Account Type'] = backendUser?.role
    }

    logEventAnalytics(
      backendUser?.partnerId ? 'Partner' : backendUser?.role,
      eventType,
      'mixpanel',
      eventType,
      { Email: backendUser?.username, ...partnerLog, ...userLog },
      backendUser?.id
    )
  }

  return {
    theme,
    isDevice,
    showPolicy,
    setShowPolicy,
    showSecurity,
    setShowSecurity,
    showTerms,
    setShowTerms,
    logEventAnalytics,
    backendPartner,
    handlerTracker
  } as const
}
